// extracted by mini-css-extract-plugin
module.exports = {"container":"Damages_container__1ec8H","page":"Damages_page__1I84w","section":"Damages_section__1PQWT"};